var exports = {
  "k": "xe7b6e3d6--1d22e4--container",
  "U": "xe7b6e3d6--1d22e4--arrow",
};

module.exports = exports;
